import { useState } from "react";
import { Wrapper, Datagrid, DeleteActionIcon, Permission } from "components";

import { Typography, IconButton, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { endpoints } from "appConfigs";
import Form from "./Form";
import Filters from "./Filters";
import { useAppState } from "components/AppProvider/AppProvider";
import { useFetch } from "hooks";
import { FormattedMessage } from "react-intl";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  titleBar: {
    padding: "1rem 0 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  centered: {
    margin: "0 auto",
  },
  label: {
    color: "#ffffff",
  },
  status: {
    textTransform: "capitalize",
  },
}));

const SalaryForm = () => {
  const { authUser } = useAppState();
  const classes = useStyles();
  const [edit, setEdit] = useState(null);
  const [filters, setFilters] = useState({});
  const { remove, loading } = useFetch(endpoints.salaries);
  return (
    <>
      <Wrapper padding={false}>
        <Grid container spacing={0} justify="center">
          <Grid item xs={10}>
            <Grid container spacing={1} direction="column" justify="center">
              <Grid item className={classes.titleBar}>
                <Typography variant="h5">
                  <FormattedMessage id="salaries" defaultMessage="Salaries" />
                </Typography>
                <Permission permission="pay_salary">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setEdit(true)}
                  >
                    <FormattedMessage
                      id="paySalary"
                      defaultMessage="Pay Salary"
                    />
                  </Button>
                </Permission>
              </Grid>
              <Grid item>
                <Card>
                  <CardContent>
                    <Filters
                      filters={filters}
                      setFilters={setFilters}
                      authUser={authUser}
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item>
                <Datagrid
                  url={endpoints.salaries}
                  filters={filters}
                  columns={[
                    {
                      headerName: (
                        <FormattedMessage
                          id="createdAt"
                          defaultMessage="Created At"
                        />
                      ),
                      field: "createdAt",
                      renderCell: ({ row }) =>
                        format(new Date(row.createdAt), "dd MMM yyyy hh:mma"),
                    },
                    ...(authUser.user_type === "admin"
                      ? [
                          {
                            headerName: (
                              <FormattedMessage
                                id="hospital"
                                defaultMessage="Hospital"
                              />
                            ),
                            field: "hospital.name",
                            renderCell: ({ row }) => row.hospital?.name,
                          },
                        ]
                      : []),
                    {
                      headerName: (
                        <FormattedMessage id="doctor" defaultMessage="Doctor" />
                      ),
                      field: "doctor",
                      renderCell: ({ row }) => row.doctor?.name,
                    },
                    {
                      headerName: (
                        <FormattedMessage id="salary" defaultMessage="Salary" />
                      ),
                      field: "amount",
                      renderCell: ({ row }) =>
                        `₦${(row.amount || 0).toLocaleString()}`,
                    },
                    {
                      headerName: (
                        <FormattedMessage id="remark" defaultMessage="Remark" />
                      ),
                      field: "remark",
                    },
                    {
                      headerName: (
                        <FormattedMessage id="action" label="Action" />
                      ),
                      field: "action",
                      renderCell: ({ row }) => (
                        <>
                          <Permission permission="update_salaries">
                            <IconButton
                              aria-label={
                                <FormattedMessage
                                  id="editSalary"
                                  defaultMessage="Edit Salary"
                                />
                              }
                              onClick={() => setEdit(row)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Permission>
                          <Permission permission="remove_salaries">
                            <DeleteActionIcon
                              disabled={loading}
                              title={
                                <FormattedMessage
                                  id="deleteSalary"
                                  defaultMessage="Delete Salary"
                                />
                              }
                              message={
                                <FormattedMessage
                                  id="deleteConfirmation_salary"
                                  defaultMessage="Are you sure want to remove this salary?"
                                />
                              }
                              deleteRecord={() => {
                                remove({ ids: row.id })
                                  .then(({ data }) => {
                                    if (data.success) {
                                      setFilters((prev) => ({ ...prev }));
                                    }
                                  })
                                  .catch((err) => {
                                    NotificationManager.error(err.message);
                                  });
                              }}
                            />
                          </Permission>
                        </>
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Form
          authUser={authUser}
          open={!!edit}
          edit={edit}
          setEdit={setEdit}
          onSuccess={(newSubPackage) => {
            setFilters((prev) => ({ ...prev }));
            setEdit(null);
          }}
        />
      </Wrapper>
    </>
  );
};

export default SalaryForm;
